import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "the trashcan metaphor",
  "description": " ",
  "published": "2021-04-30T00:00:00.000Z",
  "categories": "Opinions",
  "hero": "./img/screenshot-1619796317248.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Your teacher puts down a trashcan at the front of the class.`}</p>
    <p><em parentName="p">{`"Ok class, crumple up a piece of paper and throw it in the bin from where you are"`}</em></p>
    <p>{`You can stand up, climb on your chair, even your desk. Your ball can be loose or crumpled hard, light paper or heavy. But you can't leave your spot.`}</p>
    <p>{`Ball in trash is an A. Rim is B, side of can is C, everyone else gets an F.`}</p>
    <p>{`That’s equality as it works today. Something feels unfair 🤔`}</p>
    <p>{`In life there are no guarantees and that's okay. `}<em parentName="p">{`Guaranteeing`}</em>{` success wouldn't be fair either.`}</p>
    <p>{`But you have to understand we're all running a different race.`}</p>
    <p>{`Some of us ran a marathon to start the sprint. Others have a broken leg or wind in their face. Yet others get 3 extra balls to throw at that stupid trashcan.`}</p>
    <p>{`You play the cards you have, not the cards you wish you had. Help others play theirs.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      